import { FC, useCallback } from 'react';
import { Box } from '@mui/material';
import { PolicyOption as PolicyOptionType } from '../policy-settings-types';
import PolicyOption from './PolicyOption';

const PolicySetting: FC<
  React.PropsWithChildren<PolicySettingProps>
> = props => {
  const { options, policyId, categoryId, type, onOptionSelect } = props;

  const onOptionClick = useCallback(
    (optionId: string) => {
      onOptionSelect(optionId, policyId, categoryId, type);
    },
    [categoryId, onOptionSelect, policyId, type],
  );
  return (
    <Box display='flex' flexDirection='row' gap={2}>
      {options.map(option => (
        <PolicyOption
          key={option.optionId}
          id={option.optionId}
          name={option.optionName}
          appsCount={option.appsCount}
          onOptionClick={onOptionClick}
        />
      ))}
    </Box>
  );
};

export interface PolicySettingProps {
  type: 'new' | 'old';
  options: PolicyOptionType[];
  onOptionSelect: (
    optionId: string,
    policyId: string,
    categoryId: string,
    type: 'new' | 'old',
  ) => void;
  policyId: string;
  categoryId: string;
}

export default PolicySetting;
